import * as React from 'react';
import { Dropdown, DropdownButton, Pagination } from 'react-bootstrap';
import { useEffect } from 'react';
export var AppPagination = function (_a) {
    var page = _a.page, size = _a.size, pages = _a.pages, sizes = _a.sizes, onClick = _a.onClick;
    var _b = React.useState(size), sizeState = _b[0], setSize = _b[1];
    useEffect(function () {
        setSize(size);
    }, [size]);
    var handlePaginationClick = function (paginationPage, paginationSize) { return function () { return onClick(paginationPage, paginationSize); }; };
    var paginationBuilder = function (currentPage, amountOfPages) {
        var delta = 2;
        var range = [];
        var startFrom = Math.max(2, currentPage - delta);
        var ends = Math.min(amountOfPages - 1, currentPage + delta);
        for (var i = startFrom; i <= ends; i++) {
            range.push(React.createElement(Pagination.Item, { key: i, onClick: handlePaginationClick(i, sizeState), active: i === currentPage }, i));
        }
        if (currentPage - delta > 2) {
            range.unshift(React.createElement(Pagination.Ellipsis, { key: 'first' }));
        }
        if (currentPage + delta < amountOfPages - 1) {
            range.push(React.createElement(Pagination.Ellipsis, { key: 'last' }));
        }
        // first item
        range.unshift(React.createElement(Pagination.Item, { key: 1, onClick: handlePaginationClick(1, sizeState), active: currentPage === 1 }, 1));
        // last item
        if (amountOfPages > 1) {
            range.push(React.createElement(Pagination.Item, { key: amountOfPages, onClick: handlePaginationClick(amountOfPages, sizeState), active: currentPage === amountOfPages }, amountOfPages));
        }
        return range;
    };
    var setSizeWrapper = function (eventOrKey) {
        setSize(Number(eventOrKey));
        onClick(page, Number(eventOrKey));
    };
    var sizesDropdown = (React.createElement(DropdownButton, { id: 'dropdown-basic-button', onSelect: setSizeWrapper, className: 'pagination-pill', size: 'sm', title: sizeState }, sizes.map(function (item, key) { return React.createElement(Dropdown.Item, { key: key, eventKey: item.toString() }, item); })));
    return (React.createElement("div", { className: 'd-flex pt-2 pl-2 flex-row-reverse' },
        sizesDropdown,
        React.createElement(Pagination, { size: 'sm', className: 'pr-1' },
            React.createElement(Pagination.First, { disabled: page === 1, onClick: handlePaginationClick(1, sizeState) }),
            React.createElement(Pagination.Prev, { disabled: page === 1, onClick: handlePaginationClick(page - 1, sizeState) }),
            paginationBuilder(page, pages),
            React.createElement(Pagination.Next, { disabled: page === pages, onClick: handlePaginationClick(page + 1, sizeState) }),
            React.createElement(Pagination.Last, { disabled: page === pages, onClick: handlePaginationClick(pages, sizeState) }))));
};
//# sourceMappingURL=app-pagination.js.map